export default __webpack_public_path__ + "static/media/create-off.170400af.svg";